import type { ReactElement } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  Card,
  Text,
  Logo,
  Flex,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { ApplicationContext } from "~/graphql/mainEnums";
import { useGetArenasQuery, useGetCurrentUserQuery } from "~/graphql/mainHooks";
import { toDbId } from "~/utils/graphql-helpers";
import { isFundAccountingController } from "~/utils/userRoles";
import { TransactionExport } from "./TransactionExport";

export const Arenas = (): ReactElement => {
  const { path } = useRouteMatch();
  const { data, loading, error } = useGetArenasQuery({
    context: withClientContext("staff"),
    variables: {
      includeAdminArena: false,
      applicationContext: ApplicationContext.AdminFundAccounting,
    },
  });
  const { data: userData, loading: userLoading } = useGetCurrentUserQuery({
    context: withClientContext("staff"),
  });
  const roles: string[] =
    userData?.currentUser?.roles?.edges
      .map((edge) => edge.node.name)
      .filter((name): name is string => !!name) || [];
  const isFaController = isFundAccountingController(roles);
  const history = useHistory();
  if (loading || userLoading) {
    return <Text>Loading</Text>;
  }
  if (error || !data) {
    return <Text>Error</Text>;
  }
  const arenas = data.arenas?.edges.map((e) => e.node);

  const handleRowClick = (arenaId: string) => {
    history.push(`${path}/arena/${toDbId(arenaId)}/entities`);
  };

  return (
    <>
      <Card className="inset-lg">
        <Flex justifyContent="space-between">
          <Text className="stacked-md" variant="h3">
            Managers
          </Text>
          {isFaController && <TransactionExport />}
        </Flex>
        <div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell header={true}></TableCell>
              </TableRow>
            </TableHeader>
            {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
            {/* @ts-ignore */}
            <TableBody>
              {arenas?.map((arena) => {
                return (
                  <TableRow
                    key={arena.id}
                    onClick={() => handleRowClick(arena.id)}
                    role="button"
                    tabIndex={0}
                    aria-label={arena.name}
                  >
                    <TableCell rightAligned>
                      <Flex flexDirection="row" key={arena.id}>
                        <Logo
                          className="inline-lg"
                          size="x-large"
                          name={arena.name}
                          url={arena.logoUrl}
                          aria-label={`arenaImage ${arena.id}`}
                        />
                        <Flex
                          flexDirection="row"
                          alignItems="center"
                          style={{ marginLeft: "16px" }}
                        >
                          <Text variant="strong-lg" align="right">
                            {arena.name}{" "}
                          </Text>
                        </Flex>
                      </Flex>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Card>
    </>
  );
};
